export default __webpack_public_path__ + "static/contact-info-check-95bf7b7e176861760d61b9c0fdc02533.png";